import StyledTextFieldWithTitle from "@/modules/common/components/input/styled-text-field-with-title";
import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import {
  Controller,
  FieldValues,
  Path,
  UseFormReturn,
  useWatch,
} from "react-hook-form";

export interface FinancialShareProps<T extends FieldValues> {
  form: UseFormReturn<T>;
  field: Path<T>;
  title: string;
}

export default function FinancialShare<T extends FieldValues>({
  form,
  field,
  title,
}: FinancialShareProps<T>) {
  const [unlockedPercentage, setUnlockedPercentage] = useState<number>(0);

  const ownerPercentage = useWatch({
    control: form.control,
    name: field,
  });

  useEffect(() => {
    setUnlockedPercentage(ownerPercentage ? 100 - ownerPercentage : 0);
  }, [ownerPercentage]);

  return (
    <Box
      sx={(t) => ({
        p: t.nawy.spacing.sm,
        backgroundColor: t.nawy.colors.semantic.layer.secondary,
        borderRadius: t.nawy.radius.xl,
        display: "flex",
        flexDirection: "column",
        gap: t.nawy.spacing.md,
      })}
    >
      <Typography
        sx={(t) => t.nawy.typography.english.variants.body.md.semibold}
      >
        {title}
      </Typography>
      <Box
        sx={(t) => ({
          display: "flex",
          p: t.nawy.spacing.md,
          backgroundColor: t.nawy.colors.primitives.white[100],
          borderRadius: t.nawy.radius.xl,
          gap: t.nawy.spacing.xxs,
        })}
      >
        <Controller
          control={form.control}
          name={field}
          render={({ field, fieldState }) => (
            <StyledTextFieldWithTitle
              {...field}
              formatNumeric
              title="Client share"
              placeholder="Client share"
              fullWidth
              size="small"
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              slotProps={{
                input: {
                  endAdornment: <Typography>%</Typography>,
                },
              }}
            />
          )}
        />

        <StyledTextFieldWithTitle
          formatNumeric
          title="Unlocked share"
          placeholder="Unlocked share"
          fullWidth
          size="small"
          value={unlockedPercentage.toString()}
          disabled={true}
          slotProps={{
            input: {
              endAdornment: <Typography>%</Typography>,
            },
          }}
        />
      </Box>
    </Box>
  );
}
